import React, { useEffect, useState } from 'react';
import { useBreakpoint } from '@rakutenfrance/breakpoint';
export const HideInWebview = ({ children }) => {
    const [canRenderInClient, setCanRenderInClient] = useState(true);
    const { md } = useBreakpoint();
    useEffect(() => {
        if (md.isEmbeddedInBuyerApp) {
            setCanRenderInClient(false);
        }
    }, [md]);
    if (canRenderInClient) {
        return (React.createElement(React.Fragment, null,
            React.createElement("style", { dangerouslySetInnerHTML: {
                    __html: `
            .hide-in-webview {
              display: inherit;
            }
            .is-in-webview .hide-in-webview {
              display: none;
            }
        `,
                } }),
            React.createElement("script", { type: "text/javascript", dangerouslySetInnerHTML: {
                    __html: `var isEmbbedInBuyerApp = (window.navigator.userAgent.indexOf('BuyerApp') >= 0 || window.navigator.userAgent.indexOf('MSAppHost') >= 0); 
              if(isEmbbedInBuyerApp) {
                  document.getElementsByTagName("HTML")[0].classList.add("is-in-webview");
              }`,
                } }),
            React.createElement("div", { "data-qa": "hide_in_webview", className: "hide-in-webview" }, children)));
    }
    return null;
};
